import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { ConsultorioPrivadoCreateRequest, ConsultorioPrivadoRequest, ConsultorioPrivadoResponse } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-privado.model';
import { inserirConsultorioPrivado } from '@/core/api/sicom-api/registro/medico/consultorio-privado/api/consultorio-privado-api-insert';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class ConsultorioPrivadoService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH = SICOM_PATHS.registro.medico.consultorioPrivado.consulta;

    listar(params: Pessoa, context?: HttpContext): Observable<ConsultorioPrivadoResponse[]> {
        const httpParams = new HttpParams().set('id', params.id).set('uf', params.uf);

        return this.http.get<ConsultorioPrivadoResponse[]>(this.PATH, { params: httpParams, context });
    }

    buscar(params: ConsultorioPrivadoRequest, context?: HttpContext): Observable<ConsultorioPrivadoResponse[]> {
        const httpParams = new HttpParams().set('id', params.id).set('uf', params.uf).set('idConsultorio', params.idConsultorio);

        return this.http.get<ConsultorioPrivadoResponse[]>(this.PATH, { params: httpParams, context });
    }

    inserir(pessoa: Pessoa, body: ConsultorioPrivadoCreateRequest, context?: HttpContext): Observable<ConsultorioPrivadoResponse> {
        return inserirConsultorioPrivado(this.http, this.rootUrl, pessoa, body, context).pipe(
            // retorna apenas o body do StrictHttpResponse
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            map((r) => r.body!)
        );
    }
}
